import { initializeApp } from "firebase/app";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBHgWrdxrNW0tcheACV45rzou5b4jIZmC4",
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "woo-woo-network.firebaseapp.com",
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "woo-woo-network",
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "woo-woo-network.appspot.com",
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "257418938856",
    appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:257418938856:web:6319ea7393e05ae3107c5d",
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-XNZR33LCJZ"
};

export const app = initializeApp(firebaseConfig);